import { useEffect, useRef, useState } from "react";

export default function Counter({ target, suffix = "", duration = 1500 }) {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  // Parse numeric portion, keep suffix
  const match = String(target).match(/^([\d.]+)(.*)$/);
  const num = match ? parseFloat(match[1]) : 0;
  const tail = match ? match[2] : "";

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const step = (now) => {
            const p = Math.min((now - start) / duration, 1);
            setValue(num * (1 - Math.pow(1 - p, 3)));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      });
    });
    obs.observe(el);
    return () => obs.disconnect();
  }, [num, duration]);

  const display = Number.isInteger(num) ? Math.round(value) : value.toFixed(1);
  return <span ref={ref}>{display}{tail}{suffix}</span>;
}
